import { render, staticRenderFns } from "./ImpactSection.vue?vue&type=template&id=6f8d7f09&scoped=true&"
import script from "./ImpactSection.vue?vue&type=script&lang=js&"
export * from "./ImpactSection.vue?vue&type=script&lang=js&"
import style0 from "./ImpactSection.vue?vue&type=style&index=0&id=6f8d7f09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d7f09",
  null
  
)

export default component.exports